import useMapEnum from "src/functions/mappers/use-map-enum";
import { LoanDecisionType_Enum } from "src/types/enums";

const decisionStateOptions = useMapEnum(Object.values(LoanDecisionType_Enum))

export default decisionStateOptions;
